<template>
  <div class="container" style="max-width: 900px">
    <div v-if="!loading">
      <div class="card p-3" v-if="objPlanoCliente.length === 0">
        Nenhum serviço encontrado
      </div>
      <div>
        <div class="card card-portal p-4 mb-5" v-if="objSorteio && objSorteio.numeroDaSorte">
          <div class="d-flex flex-column">
            <span>Número da sorte</span>
            <strong style="letter-spacing: 1rem; font-size: 1.5rem;">{{
            objSorteio.numeroDaSorte
            }}</strong>
          </div>
          <div class="d-flex justify-content-between" v-if="objSorteio.ultimoSorteio">
            <span>Próximo sorteio</span>
            <strong v-if="objSorteio.ultimoSorteio">{{
            formatDate(objSorteio.ultimoSorteio.dataProximoSorteio)
            }}</strong>
          </div>
          <span v-if="objSorteio.ultimoSorteio">
            <strong class="mt-3 mb-2">Último sorteio</strong>
          </span>
          <div class="border p-2" style="border-radius: 16px;" v-if="objSorteio.ultimoSorteio">
            <div class="d-flex justify-content-between">
              <span>Números sorteios</span>
              <strong>{{ objSorteio.ultimoSorteio.numeroSorteio }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span>Data do sorteio</span>
              <strong v-if="objSorteio.ultimoSorteio">{{
              formatDate(objSorteio.ultimoSorteio.dataSorteio)
              }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(item, index) of objPlanoCliente"
        class="card my-2 flex-row justify-content-between p-3 cursor-pointer" :key="index"
        @click="detalhesPlanoCliente(item.id)">
        <div class="mr-auto">
          <strong>{{ item.nome }}</strong>
          <p style="color: var(--cor-principal)">
            <small>
              <span>
                Titular
              </span>
              <span class="ml-1" v-if="item.quantidadeDependentes > 0">
                + {{ item.quantidadeDependentes }} {{ item.quantidadeDependentes > 1 ? 'Dependentes' : 'Dependente' }}
              </span>
            </small>
          </p>

        </div>
        <img style="max-width: 100px; height: auto;" :src="item.urlImagem" :alt="item.nome" />
        <span class="align-self-center h3 ml-3 mb-0" style="color: var(--cor-principal)">&#10097;</span>
      </div>

      <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">
        <button class="btn btn-sm  btn_color_system px-4  mt-4 py-2  ml-1" @click="$router.go(-1)">
          VOLTAR
        </button>
      </div>

    </div>

    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";

import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "ListarPlanoCliente",
  props: ["objPlanoCliente"],
  components: { Loading },
  data() {
    return {
      recorrencia: {},
      loading: false

    };
  },
  computed: {
    objSorteio() {
      return (this.objPlanoCliente || []).find(
        o => o.tipoServico === "SORTEIO"
      );
    }
  },
  created() {
    this.loadDetailRecorrencia();
  },
  methods: {
    loadDetailRecorrencia() {
      this.loading = true;
      apiService
        .obterDetalhePagamentoRecorrente(0)
        .then((response) => {
          this.recorrencia = response;
          this.loading = false;
        }).catch((error) => {
          this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
          this.loading = false;
        })
    },
    incluirDependentes(recorrenciaId) {
      this.$router.push(`/planos/dependnetes/${recorrenciaId}`
      );
    },
    pagamentos(recorrenciaId) {
      this.$router.push(`/minhas-parcelas/${recorrenciaId}`);
    },
    detalhesPlanoCliente(item) {
      this.$router.push(
        `/plano-do-cliente/${this.$route.params.idAssinatura}/${item}`
      );
    },
    formatDate(date) {
      return this.$moment(date, "YYYY/MM/DD").format("DD/MM/YYYY");
    },
    cancelar(pagamentoRecorrenteId) {
      this.loading = true;
      apiService
        .cancelarAssinatura(pagamentoRecorrenteId)
        .then(() => {
          this.$swal({
            title: "Solicitação de cancelamento",
            text: "Sua solicitação foi realizada com sucesso, em breve você receberá mais informações por e-mail.",
          }).then(() => {
            this.$router.push(`/minhas-recorrencias`);
            this.loading = false;
          });
        })
        .catch(() => {
          this.loading = false;
          this.$swal({ text: "Não foi possível realizar o cancelamento" });
        });
    },
    regulamneto(html) {
      this.$swal({
        title: "Regulamento",
        html: `<div style="overflow: auto;max-height: 70vh;">${html}</div>`,
        confirmButtonText: "Fechar",
      });
    },
  }
};
</script>

<style scoped lang="scss">
.card-portal {
  background-color: var(--cor-principal);
  color: #fff;
}
</style>
